import { Box, Tab, Tabs } from "@mui/material";
import { Form, Formik } from "formik";
import _ from "lodash";
import React, { useContext, useEffect, useImperativeHandle,forwardRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import validationSchema from "../../FormModel/validationSchema";
import { FormikPatchTouched } from "../../Utils/FormikPatchTouched";

//TabPanel Component for display that corresponding tab's content
function TabPanel(props) {
  const { name, value, index, getComponentByName, formData, handleChange,moveToFirstTab } =
    props;

  return (
    <>
      {value === index && (
        <>{getComponentByName(name, formData, handleChange,moveToFirstTab)}</>
      )}
    </>
  );
}

const TabForm = forwardRef((props, ref) => {
  const { t } = useTranslation("common");
  const applicationContext = useContext(KycApplicationContext);
  const [currentValidationSchema, setCurrentValidationSchema] = useState({});
  const [formValidationSchema, setFormValidationSchema] = useState({});
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  // assign  selected tab
  const assignTab = (e, obj) => {
    e.preventDefault();
    setCurrentTabIndex(obj.id);
  };

  // handled on tab changes
  const handleTabs = (e, val) => {
    e.preventDefault();
    setCurrentTabIndex(val);
  };

  // get the form validation schema based on the current widget
  function getFormValidationSchema(currentWidget) {
    return _.find(
      validationSchema,
      (obj) => obj.widgetShortName === currentWidget,
    );
  }

    useImperativeHandle(ref, () => ({
    moveToFirstTab() {
      setCurrentTabIndex(0);
    }
  }));

  useEffect(() => {
    if (applicationContext.currentWidget) {
      //set the form validation schema
      setFormValidationSchema(
        getFormValidationSchema(
          applicationContext.currentWidget.widgetShortName,
        ),
      );
    }
  }, [applicationContext.currentWidget]);

  // check if the index is last index
  function isLastIndex() {
    return currentTabIndex === props.tabList.length - 1;
  }

  // handle submit
  function _handleSubmit(values, actions) {
    if (isLastIndex()) {
      props.onSubmit(values).then(
        (res) => {
          // operations to be dont on submit to avoid issues
          actions.setTouched({});
          actions.setSubmitting(false);
        },
        (error) => {
          actions.setSubmitting(false);
        },
      );
    } else {
      props.onNext(values, getCurrentTabName()).then(
        (res) => {
          // set the current tab index
          setCurrentTabIndex(currentTabIndex + 1);
          // operations to be dont on submit to avoid issues
          actions.setTouched({});
          actions.setSubmitting(false);
        },
        (error) => {
          actions.setSubmitting(false);
        },
      );
    }
  }

  /**
   * get Current Tab name
   * @returns String
   */
  function getCurrentTabName() {
    var currentTab = _.find(props.tabList, (tab) => tab.id === currentTabIndex);
    if (currentTab) {
      return currentTab.name;
    } else {
      return null;
    }
  }

  // tasks to be performed on clicking the back button
  function _handleBack() {
    var step = currentTabIndex - 1;
    // set the tab index
    setCurrentTabIndex(step);
  }

  function moveToFirstTab() {
    setCurrentTabIndex(0);
  }

  // set the class for the active tab
  const isActive = (selectedtabIndex) => {
    return (
      " tab_panel_button " +
      (selectedtabIndex === currentTabIndex ? "tabactive" : "tab_panel_button")
    );
  };

  useEffect(() => {
    //select the default workflow on render
    if (props.tabList && props.tabList.length > 0) {
      // set the tab index
      setCurrentTabIndex(props.tabList[0].id);
    }
  }, [props.tabList]);

  function createValidationSchema(inputObj, subObj, mainObj) {
    var temp = Yup.object({
      [mainObj]: Yup.object().shape({
        [subObj]: inputObj,
      }),
    });
    return temp;
  }

  useEffect(() => {
    if (formValidationSchema && formValidationSchema.validationSchemaObj) {
      var currentTab = _.find(
        props.tabList,
        (tab) => tab.id === currentTabIndex,
      );
      if (currentTab) {
        // set the validation schema based on the tab index
        setCurrentValidationSchema(
          createValidationSchema(
            formValidationSchema.validationSchemaObj.fields[props.currentJson]
              .fields[currentTab.object],
            currentTab.object,
            props.currentJson,
          ),
        );
      }
    }
  }, [currentTabIndex, formValidationSchema]);

  

  return (
    <>
      {props.tabList && props.tabList.length > 0 && (
        <Formik
          initialValues={props.initialObjectStructure}
          validationSchema={currentValidationSchema}
          onSubmit={_handleSubmit}
          enableReinitialize={true}
          noValidate={true}
        >
          {({ isSubmitting, errors, values, handleChange }) => (
            <Form id={props.id} autoComplete="off" noValidate={true}>
              <FormikPatchTouched />
              <Box>
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  value={currentTabIndex}
                  onChange={handleTabs}
                  className="tab_panel"
                >
                  {props.tabList.map((item, index) => {
                    return (
                      <Tab
                        key={index}
                        label={item.name}
                        className={isActive(item.id)}
                        id="tab_panel_button"
                        onClick={(event) => assignTab(event, item)}
                      ></Tab>
                    );
                  })}
                </Tabs>
                {props.tabList.map((item, index) => {
                  return (
                    <TabPanel
                      key={index}
                      value={currentTabIndex}
                      index={item.id}
                      name={item.name}
                      formData={values}
                      handleChange={handleChange}
                      getComponentByName={props.getComponentByName}
                      moveToFirstTab={moveToFirstTab}
                    ></TabPanel>
                  );
                })}
              </Box>

              {errors && console.log(errors)}
              {/* When ever form data changes then raise on change props with values */}
              {props.onChange(values)}
              <div className="action_bar d-flex justify-content-between py-2">
                <div>
                  {currentTabIndex !== 0 && (
                    <Button
                      className="btn shadow-none action_btn"
                      onClick={_handleBack}
                    >
                      {t("form.back")}
                    </Button>
                  )}
                </div>
                <div>
                  <Button
                    className="btn shadow-none action_btn me-2"
                    disabled={isSubmitting}
                    type="submit"
                  >
                    {t("form.next")}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  )});

export default TabForm;
